import type { MessageKey } from './enUS';

/** Initial Polish catalog for the shared runtime and upcoming Koordinator Products pilot. */
export const PL_PL_MESSAGES = Object.freeze({
  'common.actions.cancel': 'Anuluj',
  'common.actions.close': 'Zamknij',
  'common.actions.edit': 'Edytuj',
  'common.actions.archive': 'Archiwizuj',
  'common.actions.retry': 'Spróbuj ponownie',
  'common.actions.save': 'Zapisz',
  'common.errors.generic': 'Wystąpił błąd.',
  'common.errors.required': 'To pole jest wymagane.',
  'common.status.loading': 'Ładowanie…',
  'common.status.unavailable': 'Niedostępne',
  'locale.english': 'Angielski',
  'locale.polish': 'Polski',
  'products.add': 'Dodaj produkt',
  'products.archive.confirm': 'Zarchiwizować ten produkt?',
  'products.archive.failure': 'Nie udało się zarchiwizować: {message}',
  'products.empty.body':
    'Twórz produkty bezpośrednio w Kloutsale lub połącz sklep, aby je zaimportować.',
  'products.empty.connectStore': 'Połącz sklep',
  'products.empty.create': 'Utwórz produkt',
  'products.empty.title': 'Brak produktów',
  'products.fulfillment.all': 'Wszystkie metody realizacji',
  'products.fulfillment.external': 'Magazyn / 3PL',
  'products.fulfillment.manual': 'Ręczna',
  'products.fulfillment.shopify': 'Shopify',
  'products.filters.fulfillment': 'Filtruj według realizacji',
  'products.filters.sort': 'Sortuj produkty',
  'products.filters.status': 'Filtruj według statusu',
  'products.load.failure': 'Nie udało się wczytać produktów: {message}',
  'products.price.currencyUnavailable': 'Waluta niedostępna',
  'products.search': 'Szukaj produktów',
  'products.sort.newest': 'Najnowsze',
  'products.sort.price': 'Cena',
  'products.sort.title': 'Nazwa',
  'products.status.all': 'Wszystkie',
  'products.status.approved': 'Zatwierdzony',
  'products.status.archived': 'Zarchiwizowany',
  'products.status.draft': 'Wersja robocza',
  'products.status.flagged': 'Oznaczony',
  'products.status.pendingReview': 'Oczekuje na weryfikację',
  'products.status.rejected': 'Odrzucony',
  'products.source.native': 'Kloutsale',
  'products.source.other': 'Połączony sklep',
  'products.source.rakuten': 'Rakuten',
  'products.source.shopify': 'Shopify',
  'products.source.woocommerce': 'WooCommerce',
  'products.actions.archiveAria': 'Archiwizuj produkt',
  'products.actions.editAria': 'Edytuj produkt',
  'products.title': 'Produkty',
  'products.untitled': 'Produkt bez nazwy',
} satisfies Readonly<Record<MessageKey, string>>);
